
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1504_NDialog extends Serenity.EntityDialog<Report_1504_NRow, any> {
        protected getFormKey() { return Report_1504_NForm.formKey; }
        protected getIdProperty() { return Report_1504_NRow.idProperty; }
        protected getLocalTextPrefix() { return Report_1504_NRow.localTextPrefix; }
        protected getNameProperty() { return Report_1504_NRow.nameProperty; }
        protected getService() { return Report_1504_NService.baseUrl; }
        protected getDeletePermission() { return Report_1504_NRow.deletePermission; }
        protected getInsertPermission() { return Report_1504_NRow.insertPermission; }
        protected getUpdatePermission() { return Report_1504_NRow.updatePermission; }

        protected form = new Report_1504_NForm(this.idPrefix);

    }
}